import * as React from 'react';

import CampaignPieWidget from '../campaign-pie-widget/CampaignPieWidget';
import CampaignReachPieChart from '../campaign-reach-pie-chart/CampaignReachPieChart';

import { abbrNum } from 'utils/helper/common';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./campaign-reach-widget.i18n.json'));

import './campaign-reach-widget.scss';

import type { ReportingDeliverableTypes } from 'modules/reporting/types/ReportingMetaInfo.type';

type Props = {
  totalReach: number,
  isLoading: boolean,
  reach: {
    [x: string]: number
  },
  availableTaskTypes: Array<ReportingDeliverableTypes>
};

class CampaignReachWidget extends React.Component<Props> {
  hasNoContent = () => {
    const { availableTaskTypes, totalReach } = this.props;
    return !availableTaskTypes.length || totalReach === 0;
  };

  renderContent(hasOnlyOneMetric) {
    const { reach, totalReach } = this.props;

    if (this.hasNoContent()) {
      return (
        <div className="campaign-reach-widget__empty">
          {__t('campaign_reach_widget.no_content')}
        </div>
      );
    }

    if (hasOnlyOneMetric) {
      return (
        <div className="campaign-reach-widget__total">
          {abbrNum(totalReach, { decimal: 1 })}
        </div>
      );
    }

    return (
      <div className="campaign-reach-widget__graph">
        <CampaignReachPieChart
          reach={reach}
          totalReach={totalReach}
          emptyMessage={__t('campaign_reach_widget.no_content')}
        />
      </div>
    );
  }

  render() {
    const { availableTaskTypes, totalReach, isLoading } = this.props;
    const hasNoMetric = availableTaskTypes.length === 0;
    const hasOnlyOneMetric = availableTaskTypes.length === 1;
    const total = hasNoMetric ?
      __t('campaign_reach_widget.empty_metric') :
      abbrNum(totalReach, { decimal: 1 });

    return (
      <CampaignPieWidget
        title={__t('campaign_reach_widget.title')}
        total={total}
        content={this.renderContent(hasOnlyOneMetric)}
        hideTotal={hasOnlyOneMetric}
        hasOnlyOneMetric={hasOnlyOneMetric}
        isLoading={isLoading}
      />
    );
  }
}

export default CampaignReachWidget;
